<template>
    <div class="order-delivery">
    <div class="main">
      <div v-if="showPage">
        <div v-if="orderType==0">
          <div v-if="isShopDelivery">
            <div class="delivery-content">
              <h2>商家自行配送，暂无配送信息 <a :href="'tel:'+shopTel" class="btn fr">催单</a></h2>
              <div class="tel">商家电话 <a :href="'tel:'+shopTel">{{shopTel}}</a></div>
            </div>
          </div>
          <div v-else>
            <div class="navbar col22 fixed">
              <a :class="{active: showStatus}" @click="switchInfo($event)" id="info">进程状态</a>
              <a :class="{active: !showStatus}" @click="switchInfo($event)" id="status">配送信息</a>
            </div>
            <div class="change-box" v-if="showStatus">
              <div class="status-list">
                <ul>
                  <li v-for="item in statusList">
                    <div class="text-box">
                      <h2>{{item.progressInfo}}</h2>
                      <div class="des">{{item.handlers}} <span style="color: #638bbb;">{{item.handlersTel}}</span></div>
                      <div class="time">{{formatDate(item.executionTime)}}</div>
                    </div>
                    <div class="status-tip" :class="{'transparent':statusList.length==1}"><span></span></div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="change-box" v-else>
              <ul class="order-info-box goods-list">
                <li>
                  <div class="text-box">
                    <h2>配送单号</h2>
                    <p>{{orderInfo.code}}</p>
                  </div>
                </li>
                <li>
                  <div class="text-box">
                    <h2>取单信息</h2>
                    <p class="ellipse"><span>店铺:</span>{{orderInfo.shopName}}</p>
                    <p><span>电话:</span><a :href="'tel:'+orderInfo.shopTel">{{orderInfo.shopTel}}</a></p>
                    <p><span>地址:</span>{{orderInfo.pickUpPlace}}</p>
                  </div>
                </li>
                <li>
                  <div class="text-box">
                    <h2>配送信息</h2>
                    <p><span>运费:</span>￥{{orderInfo.shopDeliveryFee}}</p>
                    <p><span>配送员:</span>{{orderInfo.deliveryName}}</p>
                    <p><span>电话:</span>{{orderInfo.deliveryTel}}</p>
                    <p><span>状态:</span>{{deliveryStatusName}}</p>
                  </div>
                </li>
                <li>
                  <div class="text-box">
                    <h2>送单信息</h2>
                    <p><span>商品总价:</span>￥{{orderInfo.orderAmount}}</p>
                    <p style="margin-bottom: .3rem"><span>支付:</span>{{orderInfo.orderStatusName}}</p>
                    <!--<p v-for="item in orderInfo.orderGoods">{{item.title}}-->
                      <!--<span :class="['fr','pri',{on: item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined}]">￥  {{item.salePrice}}</span>-->
                      <!--<span class="fr pri ori_pri" v-if="item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined">￥  {{item.originalGdAmount}}</span>-->
                      <!--<span class="fr pri ori_pri" v-else></span>-->
                      <!--<span class="fr">x{{item.number}}</span>-->
                    <!--</p>-->
                    <div v-for="item in orderInfo.orderGoods" style="overflow: hidden; margin-bottom: 0.3rem" class="goodsInfo">
                      <div class='goods-img fl' :style="{backgroundImage:'url(' + item.pic+')'}"></div>
                      <div class="fl flexcol" style="margin:0;width: 40%;">
                        <span class="goods-name ellipse">{{item.title}}</span>
                        <span class="goods_num" style="margin-top: 0.25rem">x{{item.number}}</span>
                      </div>
                      <div class="fr flexrow">

                        <span class="fr pri ori_pri" style="margin-right:0;" v-if="item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined">￥{{item.originalGdAmount}}</span>
                        <span class="fr pri ori_pri" style="margin-right:0;" v-else></span>
                        <span class="fr pri" style="margin-right:0;">￥{{item.salePrice}}</span>
                      </div>

                    </div>
                    <p><span>送达:</span>{{orderInfo.deliveryDate}} {{orderInfo.deliveryTime}}</p>
                    <p><span>单号:</span>{{orderInfo.orderCode}}</p>
                    <p><span>来源:</span>{{orderInfo.sysName}}</p>
                    <p><span>标识:</span>{{orderInfo.orderShortNum}}</p>
                    <p><span>下单:</span>{{orderCreateTime}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="status-list slef-take-status">
            <ul>
              <li v-for="item in pickupProcess">
                <div class="text-box">
                  <h2 style="font-size: .26rem">{{item.title}}</h2>
                  <!--<div class="des">{{item.name}}</div>-->
                  <div class="time">{{item.time}}</div>
                  <!--<div class="time">{{new Date(parseInt(item.time)).toLocaleString()}}</div>-->
                </div>
                <div class="status-tip" :class="{'transparent':statusList.length == 1}"><span></span></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  // import { MessageBox } from 'mint-ui'

  export default {
    data () {
      return {
        showPage: false,
        isShopDelivery: false,
        showStatus: true,
        orderId: 0,
        schoolId: '',
        statusList: [],
        orderInfo: {},
        settle_amount: 0,
        shopTel: '',
        deliveryStatusName: '',
        orderCreateTime: '',
        orderType: '',
        pickupProcess: JSON.parse(window.localStorage.getItem('pickupProcess'))
      }
    },
    computed: {
      schoolInfo () {
        return this.$store.state.schoolInfo
      },
      wxUid () {
        return this.$store.state.wxUid
      }
    },
    created () {
      var _this = this
      if (_this.$utils.resolveUrl().order_id) {
        _this.orderId = _this.$utils.resolveUrl().order_id
        if (_this.$utils.resolveUrl().order_type) {
          _this.orderType = _this.$utils.resolveUrl().order_type
        } else {
          _this.orderType = 0
        }
      } else {
        _this.orderType = window.localStorage.getItem('orderType')
        _this.orderId = window.localStorage.getItem('orderCode')
      }
      if (_this.$utils.resolveUrl().school_id) {
        _this.schoolId = _this.$utils.resolveUrl().school_id
      } else {
        _this.schoolId = _this.schoolInfo.schoolId
      }

    },
    mounted () {
      var _this = this
      if (_this.orderType == 0) {
        document.title = '配送信息'
        _this.getJudgeShopDelivery()

      } else if (_this.orderType == 1) {
        document.title = '自提单详情'
        _this.pickupProcess = JSON.parse(window.localStorage.getItem('pickupProcess')).reverse()
        _this.showPage = true
      }
    },
    methods: {
      formatDate(time){
        var date = new Date(time);

        var year = date.getFullYear(),
          month = date.getMonth() + 1,//月份是从0开始的
          day = date.getDate(),
          hour = date.getHours(),
          min = date.getMinutes(),
          sec = date.getSeconds();
        var newTime = year + '-' +
          month + '-' +
          day + ' ' +
          hour + ':' +
          min + ':' +
          sec;
        return newTime;
      },
      // 切换tab
      switchInfo: function (e) {
        var _this = this
        if(e.target.id == 'info') {
          _this.showStatus = true
          _this.getProgressLog()
        } else {
          _this.showStatus = false
          _this.getTransportInfo()
        }
      },
      //判断是否为商家配送
      getJudgeShopDelivery: function () {
        var _this = this
        var params = {
          schoolId: _this.schoolId,
          orderCode: _this.orderId
        }
        actions.getJudgeShopDelivery(_this, params, function (data) {
          _this.isShopDelivery = data.isShopDelivery
          _this.showPage = true
          if(_this.isShopDelivery) {
            //是商家配送
            _this.shopTel = data.shopTel
          } else {
            //不是商家配送
            _this.getProgressLog()
          }
        })
      },
      getTransportInfo: function () {
        var _this = this
        var params = {
          schoolId: _this.schoolId,
          orderCode: _this.orderId
        }
        actions.getTransportInfo(_this, params, function (data2) {
          _this.orderInfo = data2
          // var newDate = new Date()
          _this.orderCreateTime = _this.formatDate(data2.orderCreateTime)
          if(data2.status == 1) {
            _this.deliveryStatusName = '商家已接单'
          } else if(data2.status == 2) {
            _this.deliveryStatusName = '派单中'
          } else if(data2.status == 3) {
            _this.deliveryStatusName = '取单中'
          } else if(data2.status == 4) {
            _this.deliveryStatusName = '配送中'
          } else if(data2.status == 5) {
            _this.deliveryStatusName = '已送达'
          } else if(data2.status == 6) {
            _this.deliveryStatusName = '转单中'
          } else if(data2.status == -1) {
            _this.deliveryStatusName = '已撤销'
          }
        })
      },
      getProgressLog:function () {
        var _this = this
        var params = {
          schoolId: _this.schoolId,
          orderCode: _this.orderId
        }
        actions.getProgressLog(_this,params,function (data) {
          _this.statusList = data
        },function (data) {
          _this.$messagebox.alert(data.body.message,'')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DeliveryDetail.vue?5fd67bd5